import type { ExternalFunctionsMap } from '@powerednow/complexData/connection/api/dataWrapper';

declare const Deft: any;

export default {
    getETA: () => Deft.Injector.resolve('locationService').getETA(),
} satisfies ExternalFunctionsMap;
